import { render, staticRenderFns } from "./XlsxIcon.vue?vue&type=template&id=5e7d33eb&"
import script from "./XlsxIcon.vue?vue&type=script&lang=js&"
export * from "./XlsxIcon.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports